<template>
  <v-app>
    <Header />

    <v-main>
      <router-view />

      <ProductsCartDialog />
      <EditProductQuantityDialog />
      <ProductsOrderDialog />
      <NewOrderDialog />
      <NewSaleDialog />
      <EmptyCartDialog />
      <NewStaffDialog />
      <NewBranchDialog />
      <NewProductDialog />
      <NewGroupDialog />
      <NewExpensesGroupDialog />
      <AddGroupProductDialog />
      <AddExpenseDialog />
      <EditGroupItemCostDialog />
      <EditCartItemPriceDialog />
      <EditGroupTimelineDialog />
      <GroupAnalysesDialog />
      <BreakdownByNameDialog />
      <BreakdownByPriceDialog />
      <BreakdownByOrdersDialog />
      <BreakdownBySalesDialog />
      <NewContactDialog />
      <AnalysesReportContactListDialog />
    </v-main>

    <v-snackbar
      app
      v-model="snackbarStatus"
      transition="fade-transition"
      :color="snackbarColor"
      multi-line
      vertical
      bottom
    >
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" dark class="text-none" text @click="closeSnackbar">Close</v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import Header from "@/components/Header.vue";
// import Footer from "@/components/Footer.vue";

import ProductsCartDialog from "@/components/carts/ProductsCartDialog";
import ProductsOrderDialog from "@/components/orders/ProductsOrderDialog";
import NewOrderDialog from "@/components/orders/NewOrderDialog";
import NewSaleDialog from "@/components/sales/NewSaleDialog";
import EmptyCartDialog from "@/components/carts/EmptyCartDialog";
import NewStaffDialog from "@/components/staff/NewStaffDialog";
import NewBranchDialog from "@/components/branches/NewBranchDialog";
import NewProductDialog from "@/components/products/NewProductDialog";
import NewGroupDialog from "@/components/analyses/NewGroupDialog";
import NewExpensesGroupDialog from "@/components/analyses/NewExpensesGroupDialog";
import AddGroupProductDialog from "@/components/analyses/AddGroupProductDialog";
import AddExpenseDialog from "@/components/analyses/AddExpenseDialog";
import EditGroupItemCostDialog from "@/components/analyses/EditGroupItemCostDialog";
import EditGroupTimelineDialog from "@/components/analyses/EditGroupTimelineDialog";
import GroupAnalysesDialog from "@/components/analyses/GroupAnalysesDialog";
import BreakdownByNameDialog from "@/components/analyses/BreakdownByNameDialog";
import BreakdownByPriceDialog from "@/components/analyses/BreakdownByPriceDialog";
import BreakdownByOrdersDialog from "@/components/analyses/BreakdownByOrdersDialog";
import BreakdownBySalesDialog from "@/components/analyses/BreakdownBySalesDialog";
import NewContactDialog from "@/components/contacts/NewContactDialog";
import AnalysesReportContactListDialog from "@/components/analyses/AnalysesReportContactListDialog";
import EditCartItemPriceDialog from "@/components/carts/EditCartItemPriceDialog";
import EditProductQuantityDialog from "@/components/products/EditProductQuantityDialog";

export default {
  name: "App",

  components: {
    Header,
    // Footer,

    ProductsCartDialog,
    EditProductQuantityDialog,
    ProductsOrderDialog,
    NewOrderDialog,
    NewSaleDialog,
    EmptyCartDialog,
    NewStaffDialog,
    NewBranchDialog,
    NewProductDialog,
    NewGroupDialog,
    NewExpensesGroupDialog,
    AddGroupProductDialog,
    AddExpenseDialog,
    EditGroupItemCostDialog,
    EditCartItemPriceDialog,
    EditGroupTimelineDialog,
    GroupAnalysesDialog,
    BreakdownByNameDialog,
    BreakdownByPriceDialog,
    BreakdownByOrdersDialog,
    BreakdownBySalesDialog,
    NewContactDialog,
    AnalysesReportContactListDialog
  },

  data: () => ({}),

  methods: {
    closeSnackbar() {
      this.$store.commit("setSnackbar", { state: false });
    }
  },

  mounted() {},

  computed: {
    snackbarStatus: {
      get: function() {
        return this.$store.state.snackbar;
      },
      set: function(state) {
        this.$store.commit("setSnackbar", { state: state });
      }
    },
    snackbarColor() {
      return this.$store.state.snackbarColor;
    },
    snackbarMessage() {
      return this.$store.state.snackbarMessage;
    }
  }
};
</script>

<style></style>
